import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense, useCallback } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  productMasterSearchSchema,
  type ProductMasterSearch,
} from '~/features/catalog-enrichment/utils/product-master-search';

const ProductMasterListPage = lazy(
  () => import('~/features/catalog-enrichment/pages/product-master-list-page'),
);

/** Product master list; every filter is a URL search param so run screens can deep-link a drill-down. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/products/')({
  validateSearch: productMasterSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  // Merge a filter patch into the URL; debounced text boxes replace instead of pushing history.
  const onSearchChange = useCallback(
    (patch: Partial<ProductMasterSearch>, replace = false) => {
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace });
    },
    [navigate],
  );

  return (
    <Suspense fallback={<PageSkeleton />}>
      <ProductMasterListPage search={search} onSearchChange={onSearchChange} />
    </Suspense>
  );
}
